export const enum StakePosition {
  President = 'President',
  FirstCounselor = 'FirstCounselor',
  SecondCounselor = 'SecondCounselor'
}
